// The events that the machine handles
export enum MintEvent {
  INPUT_CHANGE = 'INPUT_CHANGE',
  CHECK_INPUT = 'CHECK_INPUT',
  MINT = 'MINT',
  SELECT_TOKEN_TO_MINT = 'SELECT_TOKEN_TO_MINT',
  RESET_MEMBER_ALLOWANCE = 'RESET_MEMBER_ALLOWANCE',
  RESET_COLLATERAL_ALLOWANCE = 'RESET_COLLATERAL_ALLOWANCE',
  APPROVE_MEMBER_ALLOWANCE = 'APPROVE_MEMBER_ALLOWANCE',
  APPROVE_COLLATERAL_ALLOWANCE = 'APPROVE_COLLATERAL_ALLOWANCE',
  UPDATE_ACCOUNT_INFO = 'UPDATE_ACCOUNT_INFO',
}
